import { render, staticRenderFns } from "./TransportationPermissionImportsTable.vue?vue&type=template&id=d9555056"
import script from "./TransportationPermissionImportsTable.vue?vue&type=script&lang=ts"
export * from "./TransportationPermissionImportsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports